export default "__VITE_ASSET__2CsfsNqb__"